import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen titles={['Upper Body / Core']} BGImage={CategoryScreenBG} />
			<MultiHalfText first='Workout 01' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Chest/Triceps',
							value: 'Push-ups',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Jacks',
						},
						{
							header: 'Sec / Minutes',
							value: '25 sec',
						},
					],
					[
						{
							header: '(A) Chest/Triceps',
							value: 'Dips',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min or 2 min',
						},
					],
					[
						{
							header: '(A) Chest/Triceps',
							value: 'Chest Press w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Knee Tucks',
						},
						{
							header: 'Sec / Minutes',
							value: '25 sec',
						},
					],
					[
						{
							header: '(A) Chest/Triceps',
							value: 'Overhead Tricep Extensions w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Bicycles',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Chest/Triceps',
							value: 'Star Jumps',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Crunch',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
